import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel, EditPageTextArea } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const NumberCreate = () => {
    const [data, setData] = useState({ status: true });
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        getOne('/admin/numbers/numbers/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, []);

    const handleSave = () => {
        if (!data.number || data.number.trim() === '') {
            toast.error("Phone number is required");
            return;
        }
        
        if (!data.capabilities || data.capabilities.trim() === '') {
            toast.error("Capabilities are required");
            return;
        }

        create('/admin/numbers/numbers', {data: data}).then(response => {
            toast.success("Number created successfully", {});
            navigate('/numbers');
        }).catch(error => {
            toast.error("Error creating Number: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/numbers');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel} title="Create Number">
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField 
                        label="Phone Number" 
                        id="number" 
                        onChange={onChange} 
                        value={data.number} 
                        required 
                        placeholder="Enter phone number"
                    />
                    <EditPageSelect 
                        label="Capabilities" 
                        id="capabilities" 
                        onChange={onChange} 
                        value={data.capabilities} 
                        options={metadata?.capabilities?.values}
                        required
                    />
                    <EditPageTextField 
                        label="Type" 
                        id="type" 
                        onChange={onChange} 
                        value={data.type} 
                        placeholder="Number type (optional)"
                    />
                    <EditPageTextField 
                        label="Country" 
                        id="country" 
                        onChange={onChange} 
                        value={data.country} 
                        placeholder="Country code (optional)"
                    />
                    <EditPageCheckbox 
                        label="Active" 
                        id="status" 
                        onChange={onChange} 
                        value={data.status} 
                    />
                </EditPagePanel>
                <EditPagePanel className="col-lg-4">
                    <EditPageSelect 
                        label="Client" 
                        id="client_id" 
                        onChange={onChange} 
                        value={data.client_id} 
                        options={metadata?.client_id?.values}
                        placeholder="Select client (optional)"
                    />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default NumberCreate;